import { useState } from 'react';
import { Sparkles, Loader2 } from 'lucide-react';
import { useAuth } from '../../store/auth';
import { usePortal } from '../../store/portal';

export function LoginScreen() {
  const { loginWithMailCredentials } = useAuth();
  const { portal, brandTitle } = usePortal();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    const { error } = await loginWithMailCredentials(email, password);
    if (error) setError(error);
    setLoading(false);
  }

  return (
    <div className="flex h-screen items-center justify-center bg-zinc-950 px-4 text-zinc-100">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center text-center">
          <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-accent-500 to-cyan-700 shadow-lg shadow-accent-500/30">
            <Sparkles size={22} className="text-white" strokeWidth={2.5} />
          </div>
          <h1 className="text-xl font-semibold tracking-tight">{brandTitle}</h1>
          <p className="mt-1 text-xs text-zinc-500">
            {portal.hostname || 'webmail.unikai.it'} · Powered by Netlab
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="space-y-3 rounded-xl border border-zinc-800/80 bg-zinc-900/40 p-6"
        >
          <p className="text-center text-xs text-zinc-400">
            Accedi con le credenziali della tua casella di posta
          </p>
          <div>
            <label className="mb-1 block text-[11px] font-medium uppercase tracking-wider text-zinc-500">
              Email
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-md border border-zinc-800 bg-zinc-950/60 px-3 py-2 text-sm outline-none transition focus:border-accent-500/50"
              autoComplete="email"
            />
          </div>
          <div>
            <label className="mb-1 block text-[11px] font-medium uppercase tracking-wider text-zinc-500">
              Password della casella
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-md border border-zinc-800 bg-zinc-950/60 px-3 py-2 text-sm outline-none transition focus:border-accent-500/50"
              autoComplete="current-password"
            />
          </div>

          {error && (
            <div className="rounded-md border border-rose-500/30 bg-rose-500/10 px-3 py-2 text-xs text-rose-300">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="flex w-full items-center justify-center gap-2 rounded-md bg-accent-500 px-3 py-2 text-sm font-medium text-white transition hover:bg-accent-600 disabled:opacity-50"
          >
            {loading && <Loader2 size={14} className="animate-spin" />}
            Accedi
          </button>

          <p className="text-center text-[11px] text-zinc-600">
            Usa email e password della tua casella: nessuna registrazione necessaria.
          </p>
        </form>
      </div>
    </div>
  );
}
